import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, isRef as _isRef, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-position"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "product-price-card__body" }
const _hoisted_4 = { class: "row g-4 g-xxl-5" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "product-price-card__slogan"
}
const _hoisted_8 = { class: "product-price-card__benefits" }
const _hoisted_9 = { class: "fa-ul" }
const _hoisted_10 = { class: "fa-li" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Vertragslaufzeit bis zum ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Vertragslaufzeit ")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "fa-li" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Preisgarantie bis zum ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Preisgarantie ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Zu Ihrem Vorteil sichern wir den reinen Energiepreis ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" bis zum ")
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "fa-li" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 100 % Ökostrom auf Wunsch möglich ")
const _hoisted_22 = { class: "fa-li" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("b", { class: "color-green" }, " Ökostrom-Option ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, " Ø pro Monat ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "product-price-card__spacer" }, null, -1)
const _hoisted_27 = { class: "product-price-card__saving text-center text-xxl-end" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Ihre Ersparnis im ersten Jahr ")
const _hoisted_29 = { class: "color-primary" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "product-price-card__spacer" }, null, -1)
const _hoisted_32 = ["href", "innerHTML"]
const _hoisted_33 = ["href", "innerHTML"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "product-price-card__spacer" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Jetzt bestellen ")

import {
  onBeforeUnmount,
  onMounted,
  PropType,
  ref,
  computed,
} from 'vue';
import Expand from '@/components/Expand.vue';
import PriceDetailsTable from '@/components/product/PriceDetailsTable.vue';
import { getRandomId } from '@/helpers';
import Checkbox from '@/components/Checkbox.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck, faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import Product from '../../classes/Product';


export default /*#__PURE__*/_defineComponent({
  props: {
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  recommended: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  position: {
    type: Number,
  },
  isSingle: {
    type: Boolean,
    required: false,
    default: () => false,
  },
},
  emits: ['order', 'cart'],
  setup(__props, { emit }) {

const props = __props

library.add(faCheck);
library.add(faInfoCircle);




const productToUse = ref<Product>(props.product);
const colLeft = ref<InstanceType<typeof HTMLElement>>();
const colRight = ref<InstanceType<typeof HTMLElement>>();
const btnSpacer = ref<InstanceType<typeof HTMLElement>>();
const cardKey = ref(getRandomId());
const useEco = computed({
  get: () => productToUse.value.useEco,
  set(val: boolean) {
    productToUse.value.setEcoParam(val);
    cardKey.value = getRandomId();
  },
});

const emitOrder = () => {
  emit('order', productToUse.value);
};

const setSpacerHeight = () => {
  if (colLeft.value && colRight.value && btnSpacer.value) {
    btnSpacer.value.style.height = '0px';
    const diff = colLeft.value.offsetHeight - colRight.value.offsetHeight;
    btnSpacer.value.style.height = `${diff}px`;
  }
};

const downloads = computed(() => {
  const rows: Record<'label' | 'href' | 'key', string>[] = [];

  if (productToUse.value.priceFileUrl) {
    rows.push({
      key: 'pricefile',
      label: 'Preisblatt',
      href: productToUse.value.priceFileUrl,
    });
  }

  const agbDocument = productToUse.value.getDocumentByKey('agb');
  if (agbDocument) {
    rows.push({
      key: agbDocument.key,
      label: agbDocument.name || '',
      href: agbDocument.url || '#',
    });
  }

  const avbDocument = productToUse.value.getDocumentByKey('avb');
  if (avbDocument) {
    rows.push({
      key: avbDocument.key,
      label: avbDocument.name || '',
      href: avbDocument.url || '#',
    });
  }

  return rows;
});

const bgbDocument = computed(() => productToUse.value.getDocumentByKey('bgb'));

onMounted(() => {
  window.addEventListener('resize', setSpacerHeight);
  window.addEventListener('load', setSpacerHeight);
  setSpacerHeight();
  setTimeout(setSpacerHeight, 250);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setSpacerHeight);
  window.removeEventListener('load', setSpacerHeight);
});

return (_ctx: any,_cache: any) => {
  const _component_IoTooltip = _resolveComponent("IoTooltip")!
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-price-card", { recommended: __props.recommended }]),
    "data-position": __props.position
  }, [
    (productToUse.value.getRecommendationText(__props.isSingle))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "recommendation fs-h4",
          innerHTML: productToUse.value.getRecommendationText(__props.isSingle)
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "col-12 col-xxl",
          ref: (_value, _refs) => {
            _refs['colLeft'] = _value
            colLeft.value = _value
          }
        }, [
          _createElementVNode("div", {
            class: "product-price-card__title",
            innerHTML: productToUse.value.name
          }, null, 8, _hoisted_5),
          (productToUse.value.slogan)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "product-price-card__slogan",
                innerHTML: productToUse.value.slogan
              }, null, 8, _hoisted_6))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, " Günstig und zuverlässig ")),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", null, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-check" })
                ]),
                (productToUse.value.contractTermIsFixed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_11
                    ], 64))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(productToUse.value.contractTermLabel) + " ", 1),
                (!productToUse.value.contractTermIsFixed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_12
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (productToUse.value.hasPriceGuarantee)
                ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-check" })
                    ]),
                    (productToUse.value.priceGuaranteeIsFixed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_15
                        ], 64))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(productToUse.value.priceGuaranteeLabel) + " ", 1),
                    (!productToUse.value.priceGuaranteeIsFixed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_16
                        ], 64))
                      : _createCommentVNode("", true),
                    _createVNode(_component_IoTooltip, { class: "color-primary" }, {
                      title: _withCtx(() => [
                        _hoisted_17,
                        (productToUse.value.priceGuaranteeIsFixed)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_18
                            ], 64))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(productToUse.value.priceGuaranteeLabel) + " ab. Die Preissicherheit gilt ab dem voraussichtlichen Lieferbeginn und schützt Sie vor Marktpreisschwankungen. Die Preissicherheit ist eingeschränkt, da wir gemäß §7 unserer AGB neue oder geänderte staatlich veranlasste Abgaben wie z. B. Steuern, die ca ⅔ des Gesamtpreises ausmachen, weitergegeben werden. ", 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-info-circle" })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (productToUse.value.hasEco)
                ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-check" })
                    ]),
                    _hoisted_21
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productToUse.value.benefits, (benefit, binx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `${productToUse.value.id}-benefit-${binx}`
                }, [
                  _createElementVNode("span", _hoisted_22, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-check" })
                  ]),
                  _createElementVNode("span", { innerHTML: benefit }, null, 8, _hoisted_23)
                ]))
              }), 128))
            ])
          ]),
          (productToUse.value.hasEco)
            ? (_openBlock(), _createBlock(Checkbox, {
                key: 2,
                modelValue: _unref(useEco),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(useEco) ? (useEco).value = $event : null))
              }, {
                default: _withCtx(() => [
                  _hoisted_24,
                  _createTextVNode(" (" + _toDisplayString(productToUse.value.getAbsPriceFormatted('eco')) + " € " + _toDisplayString(productToUse.value.getPriceValue('eco') >= 0 ? 'zusätzlich' : 'weniger') + " pro Monat) ", 1)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_BaseSpacer, { size: "s" }),
          _createVNode(Expand, { title: "Preisdetails" }, {
            default: _withCtx(() => [
              _createVNode(PriceDetailsTable, {
                product: productToUse.value,
                key: `details-${cardKey.value}`
              }, null, 8, ["product"])
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", {
          class: "col-12 col-xxl-auto align-self-start",
          ref: (_value, _refs) => {
            _refs['colRight'] = _value
            colRight.value = _value
          }
        }, [
          (_openBlock(), _createElementBlock("div", {
            class: "product-price-card__monthly text-center text-xxl-end",
            key: `monthly-${cardKey.value}`
          }, [
            _createTextVNode(_toDisplayString(productToUse.value.getPriceFormatted('monthly')) + " € ", 1),
            _hoisted_25
          ])),
          _hoisted_26,
          (productToUse.value.getPriceValue('savingsYearly') > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("b", _hoisted_29, _toDisplayString(productToUse.value.getPriceFormatted('savingsYearly')) + " €", 1),
                  _hoisted_30,
                  _createVNode(_component_IoTooltip, { class: "color-primary" }, {
                    title: _withCtx(() => [
                      _createTextVNode(" Ihr lokaler Versorger kann auch andere, günstigere " + _toDisplayString(productToUse.value.branchTranslated) + "produkte anbieten. Sollten Sie dort einen anderen Tarif haben, kann der ausgewiesene Preisvorteil, sowie bspw. Vertragslaufzeiten, Kündigungsfristen, Preisgarantie etc. abweichen. In der Grundversorgung haben Sie grundsätzlich eine zweiwöchige Kündigungsfrist. ", 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-info-circle" })
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_31
              ], 64))
            : _createCommentVNode("", true),
          (_openBlock(), _createElementBlock("ul", {
            class: "product-price-card__downloads text-center text-xxl-end",
            key: `downloads-${cardKey.value}`
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(downloads), (download, inx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `product-${productToUse.value.id}-download-${inx}`
              }, [
                _createElementVNode("a", {
                  href: download.href,
                  target: "_blank",
                  innerHTML: download.label
                }, null, 8, _hoisted_32)
              ]))
            }), 128))
          ])),
          (_unref(bgbDocument))
            ? (_openBlock(), _createElementBlock("ul", {
                class: "product-price-card__downloads text-center text-xxl-end",
                key: `bgb-${cardKey.value}`
              }, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: _unref(bgbDocument).url || '#',
                    target: "_blank",
                    innerHTML: _unref(bgbDocument).name
                  }, null, 8, _hoisted_33)
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_34,
          _createElementVNode("div", {
            class: "product-price-card__spacer d-none d-xxl-block",
            ref: (_value, _refs) => {
              _refs['btnSpacer'] = _value
              btnSpacer.value = _value
            }
          }, null, 512),
          _createVNode(_component_BaseButton, {
            align: "end",
            onClick: _withModifiers(emitOrder, ["prevent"])
          }, {
            default: _withCtx(() => [
              _hoisted_35
            ]),
            _: 1
          }, 8, ["onClick"])
        ], 512)
      ])
    ])
  ], 10, _hoisted_1))
}
}

})